import {GET_ALL_NOTIFICATION} from '../types'

const INITIAL_STATE = {
  getAllnotification: [],
  unread_count: null,
}

const notificationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_NOTIFICATION:
      return {
        ...state,
        getAllnotification: payload.data,
        unread_count: payload.unread_count,
      }
    default:
      return state
  }
}

export default notificationReducer
